import orderStatus, { OrderStatus } from 'constants/orderStatus';

export const isOrderFailedPayment = (status: OrderStatus | string | undefined): boolean =>
  status === orderStatus.PAYMENT_FAILED;
